import { render } from "./CopyLink.vue?vue&type=template&id=f4b61cf0&scoped=true"
import script from "./CopyLink.vue?vue&type=script&lang=js"
export * from "./CopyLink.vue?vue&type=script&lang=js"

import "./CopyLink.vue?vue&type=style&index=0&id=f4b61cf0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4b61cf0"]])

export default __exports__